/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ProductsoverviewQuery($uid: String!) {
    prismic {
      productsoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ProductsoverviewBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_ProductsoverviewBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_ProductsoverviewBodyLeftslidingnavcards {
          type
            primary {
              background_color
              background_image
              text_color
              cta_button_text
              cta_button_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_button_color
            }
            label
            fields {
              heading
              heading_color
              subheading
              subheading_color
              card_1_copy
              card_1_image
              card_1_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_1_title
              card_2_copy
              card_2_image
              card_2_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_2_title
              card_3_copy
              card_3_image
              card_3_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_3_title
              card_4_copy
              card_4_image
              card_4_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_4_title
              card_5_copy
              card_5_image
              card_5_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_5_title
              card_6_copy
              card_6_image
              card_6_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_6_title
              card_7_copy
              card_7_image
              card_7_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_7_title
              card_8_copy
              card_8_image
              card_8_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_8_title
              card_9_copy
              card_9_image
              card_9_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              card_9_title
            }
        },
        ... on PRISMIC_ProductsoverviewBodyQuote {
          type
            label
            primary {
              quote
              align_content
              author_details
              author_image
              author_name
              background_color
              background_image
              logo
              text_color
            }
        },
        ... on PRISMIC_ProductsoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Productsoverview = ({ data, location }) =>
  data.prismic.productsoverview ? (
    <MainLayout location={location} layout='productsoverview'>
    <Helmet>
      <title>{(data.prismic.productsoverview.title[0] && data.prismic.productsoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.productsoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.productsoverview.path : 'https://www.digitalocean.com' + data.prismic.productsoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.productsoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.productsoverview.title[0] ? data.prismic.productsoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.productsoverview.description ? data.prismic.productsoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.productsoverview.open_graph_image ? data.prismic.productsoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.productsoverview.description ? data.prismic.productsoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.productsoverview.title[0] ? data.prismic.productsoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.productsoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.productsoverview.path : 'https://www.digitalocean.com' + data.prismic.productsoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.productsoverview.open_graph_image ? data.prismic.productsoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.productsoverview.body} />
    </MainLayout>
  ) : null;

Productsoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Productsoverview;
